import type { Demand } from '../types/demand'
import { deriveStaffing } from './staffing'
import { NO_CATEGORIES, coveredSkills, type SkillIndex } from './skillMatch'

/** `index` lets a whole category count, the rule the closing-soon email uses too. */
export function opportunityReminders(
  demands: Demand[], savedIds: number[], skillNames: string[], engagedIds: Set<number>,
  now = Date.now(), index: SkillIndex = NO_CATEGORIES,
): Demand[] {
  const horizon = now + 2 * 86_400_000
  return demands.filter((d) => {
    const closes = d.application_closes_at ? Date.parse(d.application_closes_at) : NaN
    const opens = d.application_opens_at ? Date.parse(d.application_opens_at) : null
    // Closed by council or the caretaker: nothing left to apply for.
    return !d.deleted_at && !d.applications_closed_at && deriveStaffing(d).recruiting &&
      (opens === null || opens <= now) && closes > now && closes <= horizon &&
      !engagedIds.has(d.id) &&
      (savedIds.includes(d.id) || coveredSkills(index, skillNames, d.skills).length > 0)
  }).sort((a, b) => Date.parse(a.application_closes_at!) - Date.parse(b.application_closes_at!))
}
